// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1537586d283e9b5e6a9e","678":"80ad1de5e10640996c22","883":"d6c6395d8fa19a3517f7"}[chunkId] + ".js";
};